/*
 * @Author: Latte
 * @Date: 2021-12-21 14:23:04
 * @LAstEditors: Latte
 * @LastEditTime: 2022-01-04 12:19:51
 * @FilePath: \Siui.Cloud.Medical.Web\src\assets\constant\index.js
 */
// 储存项目常量
// 定义时间常量
export const TODAY = 0
export const WITHIN_A_WEEK = 7
export const WITHIN_A_MONTH = 30
export const TOTAL = "total"

// 根据类型获取用户数据统计
// 0-新用户数目，1-活跃用户数目，2-累计登录过的用户数目，3-累计用户数目，4-启动次数
export const NEW_USERS = 0
export const ACTIVE_USERS = 1
export const LOGGED_USERS = 2
export const TOTAL_USERS = 3
export const OPERATION_COUNTS = 4

// 用户终端类型
export const Android = 0
export const iOS = 1

// 存储用户信息的key
export const USER_KEY = "__user__"